import {
  TravelExpenseAuditNoteReviewDTO,
  TravelExpenseAuditNoteReviewSTO,
} from "../../models/travel-expense-note-preview";
import { BaseApiService } from "../base";

export class TravelExpenseAuditNoteReviewApiService extends BaseApiService<
  TravelExpenseAuditNoteReviewDTO,
  TravelExpenseAuditNoteReviewSTO
> {
  constructor() {
    super({
      servicePath: "/EmployeeExpenseReports",
      loadItemsPath: "",
      saveItemsPath: "/SaveTravelExpenseAuditNoteReview",
    });
  }
}
